import API from "../../../../../services/api";

export const API_SUBTIPOS_INCIDENCIAS = {
  getSubtiposIncidencia: async () => {
    return await API.get("/subtipos-incidencia").then((res) => res.data);
  },
  addSubtipoIncidencia: async (data) => {
    return await API.post("/subtipos-incidencia", data).then((res) => res.data);
  },
  editSubtipoIncidencia: async (id, data) => {
    return await API.put(`/subtipos-incidencia/${id}`, data).then((res) => res.data);
  }
}